
import CategoryHeader from './category-header.vue';
import { gameConfigCategoryResourceType } from '@/store/creative/common/category';

export default {
  components: {
    CategoryHeader: CategoryHeader
  },

  props: ['groupItem', 'category'],

  name: 'template-config-category',

  computed: {
    // 游戏玩法配置分类标题支持修改，所以需要渲染出来
    isRenderGameConfigArrayHeader: function isRenderGameConfigArrayHeader() {
      var category = this.category;
      if (category.resource_type === gameConfigCategoryResourceType && category.sub_category && category.sub_category.length) {
        return true;
      }
      return false;
    }
  }
};